module.exports = __webpack_public_path__ + "img/reportes.e756d257.svg";